import { Button, Col, Progress, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { UserService } from '../../Services/UserService';
import { TextService } from '../../Services/TextService';
import { mapSubscriptionLevelFromString } from '../../Mappers/mapSubscriptionLevel';
import { CompanyService } from '../../Services/CompanyService';
import InnerHTML from 'dangerously-set-html-content'
import { WebApiPaymentRepositoryStripeInitiatePaymentResponse } from '../../Repository/eventbookyapi';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';

const FinalizePremiumRegistration = () => {
    const GetText = TextService.GetText;
    let params = useParams();
    const navigation = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const token = searchParams.get("token");
    const subscription = searchParams.get("subscription");
    const newUser = searchParams.get("newUser");
    const tokenExpires = searchParams.get("tokenExpires");
    const mfa = searchParams.get("mfa");

    useEffect(() => {
        if (newUser === "true") {
            const lang = getCurrentLanguage();
            const params = new URLSearchParams({ subscription: subscription ?? "", token: token ?? "", tokenExpires: tokenExpires ?? "" });
            if (mfa) params.set("mfa", mfa);
            navigation(`/${lang}/CompleteExternalRegistration?${params.toString()}`);
        }
    }, []);
    const [initiatePayment, setInitiatePayment] = useState({} as WebApiPaymentRepositoryStripeInitiatePaymentResponse);

    const finishPaymentSteps = () => {
        if (token && subscription) {
            UserService.AuthenticateWithToken(token).then(result => {
                const level = mapSubscriptionLevelFromString(subscription);
                CompanyService.InitiatePayment(level, window.location.href).then(result => {
                    setInitiatePayment(result);
                    window.location.href = result.url!;
                });
            });
        }
    };

    return <div id="start">
        <Row justify="center" align="top">
            <Col span={12} className='bookyBox'>
                <Title>{GetText("FinalizeRegistration_Title")}</Title>


                <Progress percent={90} status="success" /><br></br>
                {GetText("FinalizeRegistration_Description")}<br></br><br />
                <Button type="primary" size="large" onClick={finishPaymentSteps}>
                    {GetText("FinalizeRegistration_Activate")}</Button>
            </Col>
        </Row>

    </div>
}

export default FinalizePremiumRegistration;